import type { OrderDocumentAddressCandidate } from "~/shared/documents/order-document-source";

/** Carrier Instructions modal fields mapped to PDF bands in pickup-instructions/base.hbs. */
export type CarrierInstructionAddressField = "pickUpLocation" | "consignor" | "consignee";

const deliveryKind: OrderDocumentAddressCandidate["kind"] = "delivery";

/** Destination-side kinds are not valid consignee shortcuts on Carrier Instructions. */
const consigneeAllowedKinds = new Set<OrderDocumentAddressCandidate["kind"]>(["delivery", "customer"]);

/** Limit address-source shortcuts per field; manual entry is unchanged in the select. */
export const filterCarrierInstructionAddressCandidates = (
  candidates: OrderDocumentAddressCandidate[],
  field: CarrierInstructionAddressField,
): OrderDocumentAddressCandidate[] => {
  if (field === "consignee") {
    return candidates.filter(candidate => consigneeAllowedKinds.has(candidate.kind));
  }
  return candidates.filter(candidate => candidate.kind !== deliveryKind);
};
